export default "__VITE_ASSET__OZ9Yj9zy__"